// Shared helpers for trends tabs.

// Hand-picked categorical palette — high enough contrast on the dark theme,
// stays distinguishable for a stacked area of ~8 series + an Other bucket.
export const TRENDS_PALETTE = [
  '#6c8cff', // accent
  '#e07060',
  '#f0b440',
  '#7fc94c',
  '#56b3c4',
  '#b88cff',
  '#e070b8',
  '#a09080',
  '#888888', // reserved for "Other"
];

export function colorFor(i: number): string {
  return TRENDS_PALETTE[i % TRENDS_PALETTE.length];
}

// Deterministic ISO-2 → colour map for country-coloured charts. Shared by
// the landing hero stacked area and the Top Countries leaderboard so the
// same country reads the same colour everywhere. Falls back to grey.
export const COUNTRY_COLORS: Record<string, string> = {
  RU: '#e07060', CN: '#f0b440', IR: '#b88cff', KP: '#7fc94c',
  US: '#6c8cff', IL: '#56b3c4', IN: '#e070b8', KR: '#a0c060',
  TR: '#d4825c', VN: '#8a7adf', UA: '#ffd66b', BY: '#9b7be0',
  PK: '#4fb89a', GB: '#cf8acf',
  // Neutral grey for the synthetic "Unattributed" band so it visually
  // reads as "not a country" alongside real flags.
  UNK: '#9aa4b2',
  __OTHER__: '#666',
};

export function colorForCountry(code: string): string {
  return COUNTRY_COLORS[code.toUpperCase()] ?? '#888';
}

/** Map a Neo4j label to the entity-detail route segment. */
export function entityHref(label: string, name: string): string | null {
  if (!name) return null;
  const enc = encodeURIComponent(name);
  switch (label) {
    case 'MalwareFamily':
      return `/families/${enc}`;
    case 'ThreatActor':
      return `/actors/${enc}`;
    default:
      return null;
  }
}
